package fr.manyverse.app.domain.model

data class DieConfig(
    val type: DieType,
    val criticalMin: Int? = null,
    val criticalMax: Int? = null,
    val highValuesWin: Boolean = true
)

enum class DiceOutcome { CRITICAL_SUCCESS, CRITICAL_FAILURE, NORMAL }

/**
 * Détermine le résultat critique d'une valeur selon le sens de victoire de l'univers.
 *
 * Les seuils sont stockés bruts : [criticalMin] = borne basse, [criticalMax] = borne haute.
 * Le sens [highValuesWin] décide laquelle des bornes est une réussite ou un échec.
 */
fun diceOutcome(
    value: Int,
    criticalMin: Int?,
    criticalMax: Int?,
    highValuesWin: Boolean
): DiceOutcome {
    val lowHit = criticalMin != null && value <= criticalMin
    val highHit = criticalMax != null && value >= criticalMax
    return when {
        highHit -> if (highValuesWin) DiceOutcome.CRITICAL_SUCCESS else DiceOutcome.CRITICAL_FAILURE
        lowHit -> if (highValuesWin) DiceOutcome.CRITICAL_FAILURE else DiceOutcome.CRITICAL_SUCCESS
        else -> DiceOutcome.NORMAL
    }
}

fun DieConfig.outcomeFor(value: Int): DiceOutcome =
    diceOutcome(value, criticalMin, criticalMax, highValuesWin)
